export const ROUTE_HOME = '/:lang';
export const ROUTE_LOGIN = '/login';
export const ROUTE_DOCS_LANDS = 'lands';
export const ROUTE_DOCS_PROJECTS = 'projects';
export const ROUTE_DOCS_MONITORING = 'monitoring';
export const ROUTE_DOCS_REPORTS = 'reports';
export const ROUTE_DOCS_PERSONNEL = 'responsible-personnel';
export const ROUTE_DOCS_AGRO_TECHNICAL_EVENTS = 'agro-technical-events';
export const ROUTE_DOCS_STEWARDSHIP = 'stewardship';
export const ROUTE_TEACHER_STUDENT = 'teacher-student';
export const ROUTE_COTTON_ANALYTICAL = 'cotton-analytical';
export const ROUTE_TEACHER_STUDENT_STAT = 'teacher-student-stat';
